import Heading from 'basics/Heading'
import Spacer from 'basics/Spacer'
import Footer from 'features/Footer'
import Hero from 'features/Hero'
import Masthead from 'features/Masthead'
import PageLayout from 'layouts/PageLayout'
import GridContainer from 'containers/GridContainer'
import SupportingContent from 'layouts/SupportingContent'
import SupportingContentBlocks from 'features/SupportingContentBlocks'
import { FinanceFormQuery } from 'queries/equipment-finance-application'
import { GQLClient } from 'services/graphql'
import { Flatten, PickFirst } from 'services/utils'
import { GetCachedData, GetMetaData } from 'services/data.service'
import { ClassNames } from 'services/classname.service'
import { useRouter } from 'next/router'
import { useState, useRef, useReducer } from 'react'
import styles from 'styles/EquipmentFinanceApplication.module.scss'
import TextBlock from 'layouts/TextBlock/TextBlock'
import MaskInput from 'react-maskinput'
import { nanoid } from 'nanoid'
import TextInput from 'basics/TextInput'
import Divider from 'basics/Divider/index'
import Button from 'basics/Button'
import Select from 'basics/Select'
import ReCAPTCHA from 'react-google-recaptcha'
import * as Sentry from "@sentry/nextjs";

const FinanceForm = ({
  queryFinanceFormContents = [],
  queryTopNavContents = [],
  queryMainNavContents = [],
  footerContent = {},
  meta = {},
  applicationSettings = {}
}) => {
  const content = PickFirst(queryFinanceFormContents)
  const topNav = PickFirst(queryTopNavContents)
  const mainNav = PickFirst(queryMainNavContents)
  const formReducer = (state, event) => {
    if (event.reset) {
      return {}
    }
    return {
      ...state,
      [event.name]: event.value
    }
  }

  const owner = {
    First_Name__c: '',
    Last_Name__c: '',
    Home_Street__c: '',
    Home_City__c: '',
    Home_State__c: '',
    Home_Zip__c: '',
    US_Citizen__c: '',
    Title__c: '',
    SSN__c: '',
    id: nanoid()
  }

  const USstates = [
    { value: 'AL', label: 'AL' },
    { value: 'AK', label: 'AK' },
    { value: 'AS', label: 'AS' },
    { value: 'AZ', label: 'AZ' },
    { value: 'AR', label: 'AR' },
    { value: 'CA', label: 'CA' },
    { value: 'CO', label: 'CO' },
    { value: 'CT', label: 'CT' },
    { value: 'DE', label: 'DE' },
    { value: 'DC', label: 'DC' },
    { value: 'FM', label: 'FM' },
    { value: 'FL', label: 'FL' },
    { value: 'GA', label: 'GA' },
    { value: 'GU', label: 'GU' },
    { value: 'HI', label: 'HI' },
    { value: 'ID', label: 'ID' },
    { value: 'IL', label: 'IL' },
    { value: 'IN', label: 'IN' },
    { value: 'IA', label: 'IA' },
    { value: 'KS', label: 'KS' },
    { value: 'KY', label: 'KY' },
    { value: 'LA', label: 'LA' },
    { value: 'ME', label: 'ME' },
    { value: 'MH', label: 'MH' },
    { value: 'MD', label: 'MD' },
    { value: 'MA', label: 'MA' },
    { value: 'MI', label: 'MI' },
    { value: 'MN', label: 'MN' },
    { value: 'MS', label: 'MS' },
    { value: 'MO', label: 'MO' },
    { value: 'MT', label: 'MT' },
    { value: 'NE', label: 'NE' },
    { value: 'NV', label: 'NV' },
    { value: 'NH', label: 'NH' },
    { value: 'NJ', label: 'NJ' },
    { value: 'NM', label: 'NM' },
    { value: 'NY', label: 'NY' },
    { value: 'NC', label: 'NC' },
    { value: 'ND', label: 'ND' },
    { value: 'MP', label: 'MP' },
    { value: 'OH', label: 'OH' },
    { value: 'OK', label: 'OK' },
    { value: 'OR', label: 'OR' },
    { value: 'PW', label: 'PW' },
    { value: 'PA', label: 'PA' },
    { value: 'PR', label: 'PR' },
    { value: 'RI', label: 'RI' },
    { value: 'SC', label: 'SC' },
    { value: 'SD', label: 'SD' },
    { value: 'TN', label: 'TN' },
    { value: 'TX', label: 'TX' },
    { value: 'UT', label: 'UT' },
    { value: 'VT', label: 'VT' },
    { value: 'VI', label: 'VI' },
    { value: 'VA', label: 'VA' },
    { value: 'WA', label: 'WA' },
    { value: 'WV', label: 'WV' },
    { value: 'WI', label: 'WI' },
    { value: 'WY', label: 'WY' }
  ]
  const successMessage = useRef()
  const emailField = useRef()
  const [ownerList, setOwnerList] = useState([owner])
  const [formData, setFormData] = useReducer(formReducer, {})
  const [submitting, setSubmitting] = useState(false)
  const [formSuccess, setSuccess] = useState(false)
  const [formError, setError] = useState(false)
  const [invalidEmail, setInvalidEmail] = useState(false)
  const [equipmentLocation, setEquipmentLocation] = useState(null)
  const [recaptchaSuccess, setRecaptcha] = useState(false)
  const [showModal, setModal] = useState(false)
  const [modalTop, setModalTop] = useState(0)
  const recaptchaKey = process.env.RECAPTCHA_KEY

  const addOwner = () => {
    let newList = [...ownerList]
    let newOwner = owner
    newOwner.id = nanoid()
    newList.push(newOwner)
    setOwnerList(newList)
    setTimeout(() => {
      document.getElementById(newOwner.id).scrollIntoView({ behavior: 'smooth' })
      document.getElementById('First_Name__c-' + newOwner.id).focus()
    }, 250)
  }

  const removeOwner = (id) => {
    if (ownerList.length > 1) {
      const updatedOwners = ownerList.filter((item) => item.id !== id)
      setOwnerList(updatedOwners)
    }
  }

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox'
    if (event.target.name === 'equipmentLocation') {
      setEquipmentLocation(event.target.checked)
    }
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value
    })
  }

  const handleOwnerChange = (event) => {
    let split = event.target.name.split('-')
    const name = split[0]
    const index = split[1].replace('-', '')
    const value = event.target.value
    let newList = [...ownerList]
    newList[index][name] = value
    setOwnerList(newList)
  }

  const captchaChange = (value) => {
    setRecaptcha(true)
  }

  const submitForm = async (e) => {

    e.preventDefault()
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formData.Primary_Contact_Email__c)) {
      setInvalidEmail(false)
    } else {
      setInvalidEmail(true)
      emailField.current.scrollIntoView({ behavior: 'smooth' })
      alert('Please enter a valid email address in the "Primary Contact Email Address" field.')
      return
    }
    delete formData.equipmentLocation
    delete formData.AuthorizedOwners
    delete formData.AuthorizedSubmit
    formData.Sales_Rep_Name__c = query.rep || ''
    formData.Vendor_Name__c = query.ven || ''
    let payload = {}
    payload = formData
    payload.contacts = []
    ownerList.forEach((owner) => {
      delete owner.id
      payload.contacts.push(owner)
    })
    setSubmitting(true)
    const url = process.env.FINANCE_FORM_ENDPOINT;
    const response = await fetch(url, {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*"
          }
        }
    ).catch((err) => {
        setError(true)
        setSubmitting(false)
        sendErrorToSentry(err, err.message, payload.Primary_Contact_Email__c)
    })

    if (!response || (response?.status != 'success' && response?.errmsg)) {
      setError(true)
      setSubmitting(false)
      sendErrorToSentry(response, response.errmsg, payload.Primary_Contact_Email__c)
    } else {
      setSubmitting(false)
      setSuccess(true)
      successMessage.current.scrollIntoView({ behavior: 'smooth' })
      // send gtm event
      dataLayer.push({
        'event' : 'equipmentFormSubmission',
        'message' : 'Successful submission from ' + payload.Primary_Contact_Email__c
      });
    }
  }

  const sendErrorToSentry = (error, message, email) => {
    const date = new Date();
    Sentry.captureException(error);
    Sentry.captureMessage('Form submission error: ' + message + ' | User email: ' + email + ' | ' + date);
  }

  const openModal = () => {
    setModalTop(window.scrollY + 100)
    setModal(true)
  }

  const closeModal = () => {
    setModal(false)
  }

  const router = useRouter()
  const query = router.query;
  if (router.isFallback) {
    return <>Page regenerating,reload in a second</>
  }

  if (!content) {
    return <div></div>
  }

  return (
    <PageLayout meta={meta} applicationSettings={applicationSettings}>
      <Masthead topLinks={topNav?.links || []} mainLinks={mainNav?.links || []} />

      <Hero data={content.hero[0]}></Hero>

      <Spacer size={10} mdSize={10} />

      <SupportingContent type="full" containerOptions={{ narrow: true }}>
        {formSuccess && (
          <div ref={successMessage} className="intro-paragraph font-weight-bold">
            <Spacer size={7} />
            <p>
              <br />
              <br />
              <strong>{content.confirmation}</strong>
            </p>
          </div>
        )}
        {!formSuccess && (
          <form className={styles['form']} id="financeForm" onSubmit={submitForm}>
            {submitting && <div id="processing" className={styles['processing']}></div>}
            <GridContainer gridSize={1}>
              <TextInput
                id="Legal_Name_of_Business__c"
                name="Legal_Name_of_Business__c"
                label="*Legal Name of Business"
                onChange={handleChange}
                value={formData.Legal_Name_of_Business__c || ''}
                required={true}
              />
            </GridContainer>
            <Spacer size={7} />

            <GridContainer gridGap="24" gridSize={2} className={styles['two-col']}>
              <TextInput
                id="Fed_Tax_ID__c"
                name="Fed_Tax_ID__c"
                label="*Federal Tax ID Number"
                onChange={handleChange}
                value={formData.Fed_Tax_ID__c || ''}
                required={true}
              />
              <div>
                <label htmlFor="Years_in_Business__c" className={styles['form-label']}>
                  *Years in Business
                </label>
                <input
                  id="Years_in_Business__c"
                  name="Years_in_Business__c"
                  className={styles['input']}
                  type="number"
                  min="0"
                  onChange={handleChange}
                  value={formData.Years_in_Business__c || ''}
                  required={true}
                />
              </div>
            </GridContainer>
            <Spacer size={7} />

            <GridContainer gridSize={1}>
              <TextInput
                id="Street_Address__c"
                name="Street_Address__c"
                label="*Street Address"
                onChange={handleChange}
                value={formData.Street_Address__c || ''}
                required={true}
              />
            </GridContainer>
            <Spacer size={7} />

            <div className={ClassNames([styles['flex-row'], styles['address']])}>
              <div className={styles['first']}>
                <TextInput
                  id="City__c"
                  name="City__c"
                  label="*City"
                  onChange={handleChange}
                  value={formData.City__c || ''}
                  required={true}
                />
              </div>
              <div className={styles['second']}>
                <div>
                  <label htmlFor="State__c" className={styles['form-label']}>
                    *State
                  </label>
                  <Select
                    id="State__c"
                    name="State__c"
                    className='small'
                    onChange={handleChange}
                    value={formData.State__c || ''}
                    required={true}
                    options={USstates}
                  />
                </div>
                <div>
                  <TextInput
                    id="Zip_Code__c"
                    name="Zip_Code__c"
                    className={styles['medium']}
                    label="*Zip Code"
                    onChange={handleChange}
                    value={formData.Zip_Code__c || ''}
                    required={true}
                  />
                </div>
              </div>
              <div className={styles['clear']}></div>
            </div>
            <Spacer size={7} />

            <GridContainer gridGap="24" gridSize={2} className={styles['two-col']}>
              <div>
                <label htmlFor="Telephone__c" className={styles['form-label']}>
                  *Phone
                </label>
                <MaskInput
                  id="Telephone__c"
                  name="Telephone__c"
                  className={ClassNames([styles['input'], styles['full-width']])}
                  alwaysShowMask
                  mask={'+1 (000) 000-0000'}
                  showMask
                  maskChar="_"
                  onChange={handleChange}
                  value={formData.Telephone__c || ''}
                  required={true}
                />
              </div>
              <div>
                <label htmlFor="Fax__c" className={styles['form-label']}>
                  Fax
                </label>
                <MaskInput
                  id="Fax__c"
                  name="Fax__c"
                  className={ClassNames([styles['input'], styles['full-width']])}
                  alwaysShowMask
                  mask={'+1 (000) 000-0000'}
                  showMask
                  maskChar="_"
                  onChange={handleChange}
                  value={formData.Fax__c || ''}
                />
              </div>
            </GridContainer>
            <Spacer size={7} />

            <GridContainer gridGap="24" gridSize={2} className={styles['two-col']}>
              <TextInput
                id="Primary_Contact_First_Name__c"
                name="Primary_Contact_First_Name__c"
                label="*Primary Contact First Name"
                onChange={handleChange}
                value={formData.Primary_Contact_First_Name__c || ''}
                required={true}
              />
              <TextInput
                id="Primary_Contact_Last_Name__c"
                name="Primary_Contact_Last_Name__c"
                label="*Primary Contact Last Name"
                onChange={handleChange}
                value={formData.Primary_Contact_Last_Name__c || ''}
                required={true}
              />
            </GridContainer>
            <Spacer size={7} />

            <GridContainer gridGap="24" gridSize={2} className={styles['two-col']}>
              <div ref={emailField}>
                <TextInput
                  id="Primary_Contact_Email__c"
                  name="Primary_Contact_Email__c"
                  label="*Primary Contact Email Address"
                  type="email"
                  onChange={handleChange}
                  value={formData.Primary_Contact_Email__c || ''}
                  required={true}
                />
                {invalidEmail && (
                  <div style={{color: '#ff0000'}}>Please enter a valid email address.</div>
                )}
              </div>
              <div>
                <label htmlFor="Type_of_Business_Entity__c" className={styles['form-label']}>
                  *Type of Business Entity
                </label>
                <Select
                  id="Type_of_Business_Entity__c"
                  name="Type_of_Business_Entity__c"
                  className={ClassNames([styles['small'], 'ml-0'])}
                  onChange={handleChange}
                  value={formData.Type_of_Business_Entity__c || ''}
                  required={true}
                >
                  <option value="Proprietorship">Proprietorship</option>
                  <option value="Partnership">Partnership</option>
                  <option value="Corp">Corp</option>
                  <option value="LLC">LLC</option>
                </Select>
              </div>
            </GridContainer>
            <Spacer size={7} />

            <GridContainer gridGap="24" gridSize={2} className={styles['two-col']}>
              <TextInput
                id="Equipment_Description__c"
                name="Equipment_Description__c"
                label="*Brief Equipment Description"
                onChange={handleChange}
                value={formData.Equipment_Description__c || ''}
                required={true}
              />
              <TextInput
                className={styles['currency']}
                id="Equipment_Cost__c"
                name="Equipment_Cost__c"
                label="*Equipment Cost"
                onChange={handleChange}
                value={formData.Equipment_Cost__c || ''}
              />
            </GridContainer>
            <Spacer size={7} />

            <GridContainer gridGap="24" gridSize={2} className={styles['two-col']}>
              <TextInput
                id="Equipment_Supplier__c"
                name="Equipment_Supplier__c"
                label="*Equipment Supplier"
                onChange={handleChange}
                value={formData.Equipment_Supplier__c || ''}
                required={true}
              />
            </GridContainer>
            <Spacer size={3} />

            <GridContainer gridSize={1}>
              <div className="">
                <input
                  id="equipmentLocation"
                  className={ClassNames([styles['inline-check'], 'mr-2'])}
                  type="checkbox"
                  name="equipmentLocation"
                  onChange={handleChange}
                  value={formData.equipmentLocation || ''}
                />
                <label htmlFor="equipmentLocation" className="display-inline">
                  Equipment location is different than above
                </label>
              </div>
            </GridContainer>
            <Spacer size={7} />
            {equipmentLocation && (
              <>
                <GridContainer gridSize={1}>
                  <TextInput
                    id="Equipment_Street__c"
                    name="Equipment_Street__c"
                    label="*Street Address"
                    onChange={handleChange}
                    value={formData.Equipment_Street__c || ''}
                    required={true}
                  />
                </GridContainer>
                <Spacer size={7} />

                <div className={ClassNames([styles['flex-row'], styles['address']])}>
                  <div className={styles['first']}>
                    <TextInput
                      id="Equipment_City__c"
                      name="Equipment_City__c"
                      label="*City"
                      onChange={handleChange}
                      value={formData.Equipment_City__c || ''}
                      required={true}
                    />
                  </div>
                  <div className={styles['second']}>
                    <div>
                      <label htmlFor="Equipment_State__c" className={styles['form-label']}>
                        *State
                      </label>
                      <Select
                        id="Equipment_State__c"
                        name="Equipment_State__c"
                        className='small'
                        onChange={handleChange}
                        value={formData.Equipment_State__c || ''}
                        required={true}
                        options={USstates}
                      />
                    </div>
                    <div>
                      <TextInput
                        id="Equipment_Zip_Code__c"
                        name="Equipment_Zip_Code__c"
                        className={styles['medium']}
                        label="*Zip Code"
                        onChange={handleChange}
                        value={formData.Equipment_Zip_Code__c || ''}
                        required={true}
                      />
                    </div>
                  </div>
                  <div className={styles['clear']}></div>
                </div>
                <Spacer size={7} />
              </>
            )}

            <Spacer size={7} />
            <Heading level={2} className="h4">Owners/Officers</Heading>
            <p>
              <strong>(Required of all Proprietors, Partners, and Major Shareholders)</strong>
            </p>
            <Spacer size={3} />
            {ownerList.length > 0 &&
              ownerList.map((owner, index) => (
                <div id={owner.id} key={owner.id}>
                  <GridContainer gridGap="24" gridSize={2} className={styles['two-col']}>
                    <TextInput
                      id={`First_Name__c-` + owner.id}
                      label="Legal First Name"
                      name={`First_Name__c-` + index}
                      onChange={handleOwnerChange}
                      value={ownerList[index].First_Name__c || ''}
                    />
                    <TextInput
                      id={`Last_Name__c-` + index}
                      name={`Last_Name__c-` + index}
                      label="Legal Last Name"
                      onChange={handleOwnerChange}
                      value={ownerList[index].Last_Name__c || ''}
                    />
                  </GridContainer>
                  <Spacer size={7} />

                  <GridContainer gridGap="24" gridSize={2} className={styles['two-col']}>
                    <TextInput
                      id={`Title__c-` + index}
                      name={`Title__c-` + index}
                      label="Title"
                      onChange={handleOwnerChange}
                      value={ownerList[index].Title__c || ''}
                    />
                    <TextInput
                      id={`Email_Address__c-` + index}
                      name={`Email_Address__c-` + index}
                      label="Email"
                      onChange={handleOwnerChange}
                      value={ownerList[index].Email_Address__c || ''}
                    />
                  </GridContainer>
                  <Spacer size={7} />

                  <GridContainer gridGap="24" gridSize={2} className={styles['two-col']}>
                    <TextInput
                      id={`Home_Street__c-` + index}
                      name={`Home_Street__c-` + index}
                      label="Street Address (Home)"
                      onChange={handleOwnerChange}
                      value={formData.Home_Street__c || ''}
                    />
                    <TextInput
                      id={`Mobile_Phone_Number__c-` + index}
                      name={`Mobile_Phone_Number__c-` + index}
                      label="Cell Number"
                      onChange={handleOwnerChange}
                      value={formData.Mobile_Phone_Number__c || ''}
                    />
                  </GridContainer>
                  <Spacer size={7} />

                  <div className={ClassNames([styles['flex-row'], styles['address']])}>
                    <div className={styles['first']}>
                      <TextInput
                        id={`Home_City__c-` + index}
                        name={`Home_City__c-` + index}
                        label="City"
                        onChange={handleOwnerChange}
                        value={formData.Home_City__c || ''}
                      />
                    </div>
                    <div className={styles['second']}>
                      <div>
                        <label htmlFor={`Home_State__c-` + index} className={styles['form-label']}>
                          State
                        </label>
                        <Select
                          id={`Home_State__c-` + index}
                          name={`Home_State__c-` + index}
                          className={'small'}
                          onChange={handleOwnerChange}
                          value={ownerList[index].Home_State__c || ''}
                          options={USstates}
                        />
                      </div>
                      <div>
                        <TextInput
                          id={`Home_Zip__c-` + index}
                          name={`Home_Zip__c-` + index}
                          className={styles['medium']}
                          label="Zip Code"
                          onChange={handleOwnerChange}
                          value={formData.Home_Zip__c || ''}
                        />
                      </div>
                    </div>
                    <div className={styles['clear']}></div>
                  </div>
                  <Spacer size={7} />

                  <GridContainer gridGap="24" gridSize={3} className={styles['three-col']}>
                    <div>
                      <label htmlFor={`SSN__c-` + index} className={styles['form-label']}>
                        Social Security Number
                      </label>
                      <MaskInput
                        id={`SSN__c-` + index}
                        className={ClassNames([styles['input'], styles['full-width']])}
                        alwaysShowMask
                        mask={'000-00-0000'}
                        showMask
                        maskChar="_"
                        name={`SSN__c-` + index}
                        onChange={handleOwnerChange}
                        value={ownerList[index].SSN__c || ''}
                      />
                    </div>
                    <div role="radiogroup" aria-labelledby="US_Citizen">
                      <label className={styles['form-label']} id="US_Citizen">US Citizen</label>
                      <div className="mt-3">
                        <label style={{'fontWeight':'normal', 'display':'inline-block'}}><input
                          type="radio"
                          role="radio"
                          className="mr-1"
                          name={`US_Citizen__c-` + index}
                          onChange={handleOwnerChange}
                          value={'Yes'}
                        />
                        Yes</label>
                        <label style={{'fontWeight':'normal', 'display':'inline-block'}}><input
                          type="radio"
                          role="radio"
                          className="ml-3 mr-1"
                          name={`US_Citizen__c-` + index}
                          onChange={handleOwnerChange}
                          value={'No'}
                        />
                        No</label>
                      </div>
                    </div>
                    <TextInput
                        id={`Ownership__c-` + index}
                        name={`Ownership__c-` + index}
                        label="Ownership %"
                        onChange={handleOwnerChange}
                        value={formData.Ownership__c || ''}
                      />
                  </GridContainer>
                  <Spacer size={7} />
                  {index > 0 && (
                    <>
                      <div
                        className="pseudo-link float-right"
                        onClick={() => removeOwner(owner.id)}
                      >
                        - Remove This Owner
                      </div>
                      <Spacer size={7} />
                    </>
                  )}
                  <Divider />
                  <Spacer size={7} />
                </div>
              ))}

            <div className="pseudo-link" onClick={addOwner}>
              + Add Owner
            </div>
            <Spacer size={7} />
            <GridContainer gridSize={1}>
              <div>
                <label htmlFor="AuthorizedOwners" className="sr-only">Authorize credit reports</label>
                <input
                  className={ClassNames([styles['float-check'], 'mr-2'])}
                  type="checkbox"
                  id="AuthorizedOwners"
                  name="AuthorizedOwners"
                  onChange={handleChange}
                  value={formData.AuthorizedOwners || ''}
                />
                <TextBlock>
                  <p className="font-small">
                    By checking this box the aforementioned individual(s) represents that they are a
                    proprietor, partner, or shareholder of the Applicant and authorize the
                    submission of their personal information to First Business Specialty Finance,
                    LLC (&quot;First Business Bank&quot;) electronically. The individual further
                    authorizes First Business Bank or its agents or assigns to obtain consumer credit
                    reports related to the individual(s) in consideration of this application or the
                    collection of any resultant account.
                  </p>
                </TextBlock>
              </div>
            </GridContainer>

            <Divider />

            <GridContainer gridSize={1}>
              <div>
                <label htmlFor="AuthorizedSubmit" className="sr-only">Authorize terms</label>
                <input
                  className={ClassNames([styles['float-check'], 'mr-2'])}
                  type="checkbox"
                  id="AuthorizedSubmit"
                  name="AuthorizedSubmit"
                  onChange={handleChange}
                  value={formData.AuthorizedSubmit || ''}
                />
                <div className="pseudo-link default" id="modalAnchor"><span onClick={openModal}>I agree to the Terms and Conditions</span></div>
              </div>
            </GridContainer>
            <Spacer size={5} />
            {recaptchaKey &&
              <ReCAPTCHA sitekey={recaptchaKey} onChange={captchaChange} />
            }
            <Button
              submit={true}
              // disabled={!formData.AuthorizedSubmit || !formData.AuthorizedOwners}
              disabled={!formData.AuthorizedSubmit || !formData.AuthorizedOwners || !recaptchaSuccess}
            >
              Submit Credit Application
            </Button>
            {formError && (
              <p className={ClassNames([styles['error'], 'mt-3'])}>There was an error in your submission. Please <a href="/contact-us" target="_blank">contact customer service</a> for assistance.</p>
            )}
          </form>
        )}
      </SupportingContent>

      <section className="mt-20">
        <SupportingContentBlocks blocks={content.supportingContent} />
      </section>

      <Footer
        navLinks={topNav?.links || []}
        footerLinks={mainNav?.links || []}
        footerContent={footerContent}
      />
      {showModal && (
        <>
          <div className="modal-overlay" onClick={closeModal}></div>
          <div className="modal-content" style={{top: modalTop + 'px'}}>
            <div
              dangerouslySetInnerHTML={{ __html: content.disclaimer }}
            />
            <div className="text-center mt-3">
              <Button onClick={closeModal}>Close</Button>
            </div>
          </div>
        </>
      )}
    </PageLayout>
  )
}
export default FinanceForm

export async function getStaticProps({ preview = false }) {
  const client = await GQLClient()
  const data = await client.request(FinanceFormQuery, {}).catch((err) => console.log(err))
  const FinanceFormContent = Flatten(PickFirst(data.queryFinanceFormContents))
  let fullData = Flatten(data || {})
  const pageBase = PickFirst(FinanceFormContent.pageBase)
  fullData.meta = GetMetaData(pageBase)
  fullData = Flatten(GetCachedData(fullData))
  const pageData = fullData
  const config = {
    props: pageData || {}
  }

  if (process.env.IS_PREVIEW) {
    config.revalidate = 2
  }

  return config
}
